module.exports = __webpack_public_path__ + "img/5.0570bba0.png";